import { IconButton } from '@mui/material'
import { useTwitterConnect } from '@src/hooks/use-twitter-connect'

import { AccountInfo } from '@src/types/account'
import Iconify from '../iconify'

const TwitterLogin: React.FC<{ loginSuccess: (data: AccountInfo) => void }> = ({
  loginSuccess,
}) => {
  const { handleTwitterLogin } = useTwitterConnect({
    type: 'login',
    loginSuccCallback: (data) => loginSuccess(data),
  })

  return (
    <IconButton
      onClick={() => handleTwitterLogin()}
      sx={{ border: '1px solid #e8ecee', width: 48, height: 48 }}
    >
      <Iconify icon='prime:twitter' sx={{ width: 20, height: 20 }} />
    </IconButton>
  )
}

export default TwitterLogin
